const backButtonStyles = {
  backButton: {
    alignSelf: 'self-start',
    marginLeft: -1.25,
  },
};

export default backButtonStyles;
